/**
 * Notification counts per nav link, mirroring the legacy `nav_dropdown` badges
 * (pending tasks → /myjobs, invitations → /jobs_invited, support → /mysupport,
 * unread DMs → /chat).
 *
 * Shared by the desktop "My account" dropdown (`AccountNavMenu`) and the mobile
 * drawer (`MobileNav`) — they render the same link set, so the mapping lives in
 * one place rather than being copied into both.
 *
 * Chat's count is passed separately because it comes from its own endpoint
 * (`/api/v1/chat/unread`) on its own 45s poll, not from the shared
 * notification-counts payload — same split as legacy.
 */
export interface NavCounts {
  pendingTasks: number;
  invitations: number;
  supports: number;
}

export const NO_COUNTS: NavCounts = {
  pendingTasks: 0,
  invitations: 0,
  supports: 0,
};

export function countForHref(
  href: string,
  counts: NavCounts,
  chatUnread: number,
): number {
  switch (href) {
    case "/myjobs":
      return counts.pendingTasks;
    case "/jobs_invited":
      return counts.invitations;
    case "/mysupport":
      return counts.supports;
    case "/chat":
      return chatUnread;
    default:
      return 0;
  }
}
